export default __webpack_public_path__ + "static/media/menu.b54f06c6.svg";